import asyncActionType from "../utils/reduxActions";

export const FILTER_ACTIONS = {
  FETCH_LOGO_BEGIN: "FETCH_LOGO_BEGIN",
  FETCH_LOGO: asyncActionType("FETCH_LOGO"),
  SET_SCREEN_WIDTH: "SET_SCREEN_WIDTH",

  // Auth //
  LOGIN: asyncActionType("LOGIN"),
  LOGIN_CALL: "LOGIN_CALL",
  RESET_LOGIN_ACTIONS: asyncActionType("RESET_LOGIN_ACTIONS"),
  RESET_LOGIN_ACTIONS_CALL: "RESET_LOGIN_ACTIONS_CALL",
  FORGOT_PASSWORD: asyncActionType("FORGOT_PASSWORD"),
  FORGOT_PASSWORD_CALL: "FORGOT_PASSWORD_CALL",
  RESET_PASSWORD: asyncActionType("RESET_PASSWORD"),
  RESET_PASSWORD_CALL: "RESET_PASSWORD_CALL",
  AUTHENTICATED_USER: "AUTHENTICATED_USER",
  AUTH_LOGOUT_BEGIN: "AUTH_LOGOUT_BEGIN",
  AUTH_LOGOUT: "AUTH_LOGOUT",
  RESET_ERROR_MESSAGE: "RESET_ERROR_MESSAGE",
  SHOW_MESSAGE_BOX: "SHOW_MESSAGE_BOX",

  // Dashboard //
  DASHBOARD_SUMMARY: asyncActionType("DASHBOARD_SUMMARY"),
  DASHBOARD_SUMMARY_CALL: "DASHBOARD_SUMMARY_CALL",

  PJM_DASHBOARD_SUMMARY: asyncActionType("PJM_DASHBOARD_SUMMARY"),
  PJM_DASHBOARD_SUMMARY_CALL: "PJM_DASHBOARD_SUMMARY_CALL",

  PJM_DASHBOARD_DETAIL: asyncActionType("PJM_DASHBOARD_DETAIL"),
  PJM_DASHBOARD_DETAIL_CALL: "PJM_DASHBOARD_DETAIL_CALL",

  PRM_DASHBOARD_SUMMARY: asyncActionType("PRM_DASHBOARD_SUMMARY"),
  PRM_DASHBOARD_SUMMARY_CALL: "PRM_DASHBOARD_SUMMARY_CALL",

  PRM_DASHBOARD_DETAIL: asyncActionType("PRM_DASHBOARD_DETAIL"),
  PRM_DASHBOARD_DETAIL_CALL: "PRM_DASHBOARD_DETAIL_CALL",

  CLEAR_PRM_DASHBOARD_DATA: "CLEAR_PRM_DASHBOARD_DATA",
  CLEAR_PJM_DASHBOARD_DATA: "CLEAR_PJM_DASHBOARD_DATA",
  CLEAR_POM_DASHBOARD_DATA: "CLEAR_POM_DASHBOARD_DATA",

  POM_DASHBOARD_SUMMARY: asyncActionType("POM_DASHBOARD_SUMMARY"),
  POM_DASHBOARD_SUMMARY_CALL: "POM_DASHBOARD_SUMMARY_CALL",

  POM_DASHBOARD_DETAIL: asyncActionType("POM_DASHBOARD_DETAIL"),
  POM_DASHBOARD_DETAIL_CALL: "POM_DASHBOARD_DETAIL_CALL",

  // User //
  USER_PROFILE: asyncActionType("USER_PROFILE"),
  USER_PROFILE_CALL: "USER_PROFILE_CALL",
  UPDATE_USER_PROFILE: asyncActionType("UPDATE_USER_PROFILE"),
  UPDATE_USER_PROFILE_CALL: "UPDATE_USER_PROFILE_CALL",
  UPDATE_USER_PROFILE_PICTURE: asyncActionType("UPDATE_USER_PROFILE_PICTURE"),
  UPDATE_USER_PROFILE_PICTURE_CALL: "UPDATE_USER_PROFILE_PICTURE_CALL",
  GET_SEARCH_USER: asyncActionType("GET_SEARCH_USER"),
  GET_SEARCH_USER_CALL: "GET_SEARCH_USER_CALL",
  USER_RESET_PASSWORD: asyncActionType("USER_RESET_PASSWORD"),
  USER_RESET_PASSWORD_CALL: "USER_RESET_PASSWORD_CALL",

  UPDATE_WORKING_HOURS: asyncActionType("UPDATE_WORKING_HOURS"),
  UPDATE_WORKING_HOURS_CALL: "UPDATE_WORKING_HOURS_CALL",
  SORT_ROLES: asyncActionType("SORT_ROLES"),
  SORT_ROLES_CALL: "SORT_ROLES_CALL",
  ROLES_FLAG: asyncActionType("ROLES_FLAG"),
  ROLES_FLAG_CALL: "ROLES_FLAG_CALL",
  ROLES: asyncActionType("ROLES"),
  ROLES_CALL: "ROLES_CALL",
  CREATE_ROLE: asyncActionType("CREATE_ROLE"),
  CREATE_ROLE_CALL: "CREATE_ROLE_CALL",
  UPDATE_ROLE: asyncActionType("UPDATE_ROLE"),
  UPDATE_ROLE_CALL: "UPDATE_ROLE_CALL",
  DELETE_ROLE: asyncActionType("DELETE_ROLE"),
  DELETE_ROLE_CALL: "DELETE_ROLE_CALL",
  UPDATE_PERMISSIONS: asyncActionType("UPDATE_PERMISSIONS"),
  UPDATE_PERMISSIONS_CALL: "UPDATE_PERMISSIONS_CALL",
  PERMISSIONS: asyncActionType("PERMISSIONS"),
  PERMISSIONS_CALL: "PERMISSIONS_CALL",
  SORT_USERS: asyncActionType("SORT_USERS"),
  SORT_USERS_CALL: "SORT_USERS_CALL",
  USERS: asyncActionType("USERS"),
  USERS_CALL: "USERS_CALL",
  UPDATE_USER_STATUS: asyncActionType("UPDATE_USER_STATUS"),
  UPDATE_USER_STATUS_CALL: "UPDATE_USER_STATUS_CALL",
  CREATE_USER: asyncActionType("CREATE_USER"),
  CREATE_USER_CALL: "CREATE_USER_CALL",
  UPDATE_USER: asyncActionType("UPDATE_USER"),
  UPDATE_USER_CALL: "UPDATE_USER_CALL",
  DELETE_USER: asyncActionType("DELETE_USER"),
  DELETE_USER_CALL: "DELETE_USER_CALL",
  USER_FLAG: asyncActionType("USER_FLAG"),
  USER_FLAG_CALL: "USER_FLAG_CALL",
  GROUPS: asyncActionType("GROUPS"),
  GROUPS_CALL: "GROUPS_CALL",

  // Settings //
  ACCOUNT_SETTINGS: asyncActionType("ACCOUNT_SETTINGS"),
  ACCOUNT_SETTINGS_CALL: "ACCOUNT_SETTINGS_CALL",
  UPDATE_ACCOUNT_SETTINGS: asyncActionType("UPDATE_ACCOUNT_SETTINGS"),
  UPDATE_ACCOUNT_SETTINGS_CALL: "UPDATE_ACCOUNT_SETTINGS_CALL",
  UPDATE_ACCOUNT_LOGO: asyncActionType("UPDATE_ACCOUNT_LOGO"),
  UPDATE_ACCOUNT_LOGO_CALL: "UPDATE_ACCOUNT_LOGO_CALL",

  NOTIFICATION_TOAST: "NOTIFICATION_TOAST",
  ADD_TOAST_IN_LIST: "ADD_TOAST_IN_LIST",
  REMOVE_TOAST_IN_LIST: "REMOVE_TOAST_IN_LIST",
  UPDATE_NAV_EXPAND: "UPDATE_NAV_EXPAND",
  CLOSE_MODAL: "CLOSE_MODAL",
  NOTIFICATIONS: "NOTIFICATIONS",
  GET_NOTIFICATIONS: asyncActionType("GET_NOTIFICATIONS"),
  GET_NOTIFICATIONS_CALL: "GET_NOTIFICATIONS_CALL",
  DELETE_NOTIFICATION: asyncActionType("DELETE_NOTIFICATION"),
  DELETE_NOTIFICATION_CALL: "DELETE_NOTIFICATION_CALL",
  MARK_NOTIFICATION_READ: asyncActionType("MARK_NOTIFICATION_READ"),
  MARK_NOTIFICATION_READ_CALL: "MARK_NOTIFICATION_READ_CALL",
  REMINDERS: "REMINDERS",
  CLEAR_REMINDER: asyncActionType("CLEAR_REMINDER"),
  CREATE_REMINDER: asyncActionType("CREATE_REMINDER"),
  CREATE_REMINDER_CALL: "CREATE_REMINDER_CALL",
  UPDATE_REMINDER: asyncActionType("UPDATE_REMINDER"),
  UPDATE_REMINDER_CALL: "UPDATE_REMINDER_CALL",
  GET_REMINDERS: asyncActionType("GET_REMINDERS"),
  GET_REMINDERS_CALL: "GET_REMINDERS_CALL",
  FETCH_REMINDER: asyncActionType("FETCH_REMINDER"),
  FETCH_REMINDER_CALL: "FETCH_REMINDER_CALL",
  DELETE_REMINDER: asyncActionType("DELETE_REMINDER"),
  DELETE_REMINDER_CALL: "DELETE_REMINDER_CALL",
  MARK_REMINDER_READ: asyncActionType("MARK_REMINDER_READ"),
  MARK_REMINDER_READ_CALL: "MARK_REMINDER_READ_CALL",
  REMINDER_SNOOZE: asyncActionType("REMINDER_SNOOZE"),
  REMINDER_SNOOZE_CALL: "REMINDER_SNOOZE_CALL",

  CREATE_PORTFOLIO: asyncActionType("CREATE_PORTFOLIO"),
  PORTFOLIO_CALL: "PORTFOLIO_CALL",
  PORTFOLIO: asyncActionType("PORTFOLIO"),

  CREATE_PORTFOLIO_CALL: "CREATE_PORTFOLIO_CALL",
  UPDATE_PORTFOLIO_CALL: "UPDATE_PORTFOLIO_CALL",
  GET_PORTFOLIO_DETAILS: asyncActionType("GET_PORTFOLIO_DETAILS"),
  GET_PORTFOLIO_DETAILS_CALL: "GET_PORTFOLIO_DETAILS_CALL",
  UPDATE_PORTFOLIO: asyncActionType("UPDATE_PORTFOLIO"),
  SORT_PORTFOLIOS: asyncActionType("SORT_PORTFOLIOS"),
  SORT_PORTFOLIOS_CALL: "SORT_PORTFOLIOS_CALL",
  DELETE_PORTFOLIOS: asyncActionType("DELETE_PORTFOLIOS"),
  DELETE_PORTFOLIOS_CALL: "DELETE_PORTFOLIOS_CALL",
  PORTFOLIO_FLAG: asyncActionType("PORTFOLIO_FLAG"),
  PORTFOLIO_FLAG_CALL: "PORTFOLIO_FLAG_CALL",

  // Projects
  PROJECTS_CALL: "PROJECTS_CALL",
  PROJECTS: asyncActionType("PROJECTS"),
  CREATE_PROJECT: asyncActionType("CREATE_PROJECT"),
  CREATE_PROJECT_CALL: "CREATE_PROJECT_CALL",
  GET_PROGRAMS: asyncActionType("GET_PROGRAMS"),
  GET_PROGRAMS_CALL: "GET_PROGRAMS_CALL",
  GET_PROGRAM_MANAGERS: asyncActionType("GET_PROJECT_MANAGERS"),
  GET_PROGRAM_MANAGERS_CALL: "GET_PROJECT_MANAGERS_CALL",
  GET_RESOURCES: asyncActionType("GET_RESOURCES"),
  GET_RESOURCES_CALL: "GET_RESOURCES_CALL",
  GET_PROJECT_DETAILS: asyncActionType("GET_PROJECT_DETAILS"),
  GET_PROJECT_DETAILS_CALL: "GET_PROJECT_DETAILS_CALL",
  DELETE_PROJECT: asyncActionType("DELETE_PROJECT"),
  DELETE_PROJECT_CALL: "DELETE_PROJECT_CALL",
  UPDATE_PROJECT: asyncActionType("UPDATE_PROJECT"),
  UPDATE_PROJECT_CALL: "UPDATE_PROJECT_CALL",
  SORT_PROJECTS: asyncActionType("SORT_PROJECTS"),
  SORT_PROJECTS_CALL: "SORT_PROJECTS_CALL",
  PROJECT_FLAG: asyncActionType("PROJECT_FLAG"),
  PROJECT_FLAG_CALL: "PROJECTS_FLAG_CALL",

  GET_PROJECT_BUDGET_SUMMARY: asyncActionType("GET_PROJECT_BUDGET_SUMMARY"),
  GET_PROJECT_BUDGET_SUMMARY_CALL: "GET_PROJECT_BUDGET_SUMMARY_CALL",
  
  GET_PROJECT_PROGRESS_SUMMARY: asyncActionType("GET_PROJECT_PROGRESS_SUMMARY"),
  GET_PROJECT_PROGRESS_SUMMARY_CALL: "GET_PROJECT_PROGRESS_SUMMARY_CALL",

  GET_PROJECT_DETAILS: asyncActionType("GET_PROJECT_DETAILS"),
  GET_PROJECT_DETAILS_CALL: "GET_PROJECT_DETAILS_CALL",
  
  SCOPE: asyncActionType("SCOPE"),
  SCOPE_CALL: "SCOPE_CALL",
  CREATE_SCOPE: asyncActionType("CREATE_SCOPE"),
  CREATE_SCOPE_CALL: "CREATE_SCOPE_CALL",
  SCOPE_DETAILS: asyncActionType("SCOPE_DETAILS"),
  SCOPE_DETAILS_CALL: "SCOPE_DETAILS_CALL",
  UPDATE_SCOPE: asyncActionType("UPDATE_SCOPE"),
  UPDATE_SCOPE_CALL: "UPDATE_SCOPE_CALL",
  DELETE_SCOPE: asyncActionType("DELETE_SCOPE"),
  DELETE_SCOPE_CALL: "DELETE_SCOPE_CALL",
  DUPLICATE_SCOPE: asyncActionType("DUPLICATE_SCOPE"),
  DUPLICATE_SCOPE_CALL: "DUPLICATE_SCOPE_CALL",
  SCOPE_FLAG: asyncActionType("SCOPE_FLAG"),
  SCOPE_FLAG_CALL: "SCOPE_FLAG_CALL",
  CLEAR_STATUS_REPORT: asyncActionType("CLEAR_STATUS_REPORT"),
  STATUS_REPORT: asyncActionType("STATUS_REPORT"),
  STATUS_REPORT_CALL: "STATUS_REPORT_CALL",
  
  //Milesones
  MILESTONE: asyncActionType("MILESTONE"),
  MILESTONE_CALL: "MILESTONE_CALL",
  CREATE_MILESTONE: asyncActionType("CREATE_MILESTONE"),
  CREATE_MILESTONE_CALL: "CREATE_MILESTONE_CALL",
  MILESTONE_DETAILS: asyncActionType("MILESTONE_DETAILS"),
  MILESTONE_DETAILS_CALL: "MILESTONE_DETAILS_CALL",
  UPDATE_MILESTONE: asyncActionType("UPDATE_MILESTONE"),
  UPDATE_MILESTONE_CALL: "UPDATE_MILESTONE_CALL",
  MILESTONE_FLAG: asyncActionType("MILESTONE_FLAG"),
  MILESTONE_FLAG_CALL: "MILESTONE_FLAG_CALL",
  DELETE_MILESTONE: asyncActionType("DELETE_MILESTONE"),
  DELETE_MILESTONE_CALL: "DELETE_MILESTONE_CALL",
  CLEAR_CURRENT_MILESTONE: asyncActionType("CLEAR_CURRENT_MILESTONE"),
  CLEAR_CURRENT_MILESTONE_CALL: "CLEAR_CURRENT_MILESTONE_CALL",
  RESET_MILESTONE_ERRORS: asyncActionType("RESET_MILESTONE_ERRORS"),
  RESET_MILESTONE_ERRORS_CALL: "RESET_MILESTONE_ERRORS_CALL",

  PROGRAM_CLEAR_STATUS_REPORT: asyncActionType("PROGRAM_CLEAR_STATUS_REPORT"),
  PROGRAM_STATUS_REPORT: asyncActionType("PROGRAM_STATUS_REPORT"),
  PROGRAM_STATUS_REPORT_CALL: "PROGRAM_STATUS_REPORT_CALL",

  HEALTH_STATUS_FILTER: asyncActionType("HEALTH_STATUS_FILTER"),
  HEALTH_STATUS_FILTER_CALL: "HEALTH_STATUS_FILTER_CALL",

  PROGRESS_TRACKER_FILTER: asyncActionType("PROGRESS_TRACKER_FILTER"),
  PROGRESS_TRACKER_FILTER_CALL: "PROGRESS_TRACKER_FILTER_CALL",

  SORT_SCOPEITEMS: asyncActionType("SORT_SCOPEITEMS"),
  SORT_SCOPEITEMS_CALL: "SORT_SCOPEITEMS_CALL",

  TASK: asyncActionType("TASK"),
  TASK_CALL: "TASK_CALL",
  CREATE_TASK: asyncActionType("CREATE_TASK"),
  CREATE_TASK_CALL: "CREATE_TASK_CALL",
  UPDATE_TASK: asyncActionType("UPDATE_TASK"),
  UPDATE_TASK_CALL: "UPDATE_TASK_CALL",
  UPDATE_TASK_STATUS: asyncActionType("UPDATE_TASK_STATUS"),
  UPDATE_TASK_STATUS_CALL: "UPDATE_TASK_STATUS_CALL",
  DELETE_TASK: asyncActionType("DELETE_TASK"),
  DELETE_TASK_CALL: "DELETE_TASK_CALL",
  TASK_FLAG: asyncActionType("TASK_FLAG"),
  TASK_FLAG_CALL: "TASK_FLAG_CALL",
  SORT_TASKS: asyncActionType("SORT_TASKS"),
  SORT_TASKS_CALL: "SORT_TASKS_CALL",
  DUPLICATE_TASK: asyncActionType("DUPLICATE_TASK"),
  DUPLICATE_TASK_CALL: "DUPLICATE_TASK_CALL",
  RESOURCE_SHIFTS: asyncActionType("RESOURCE_SHIFTS"),
  RESOURCE_SHIFTS_CALL: "RESOURCE_SHIFTS_CALL",
  RESOURCE_MONITOR: asyncActionType("RESOURCE_MONITOR"),
  RESOURCE_MONITOR_CALL: "RESOURCE_MONITOR_CALL",
  RESOURCE_CAPACITY: "RESOURCE_CAPACITY",

  COMMUNICATION_PLAN: asyncActionType("COMMUNICATION_PLAN"),
  COMMUNICATION_PLAN_CALL: "COMMUNICATION_PLAN_CALL",
  CREATE_COMMUNICATION_PLAN: asyncActionType("CREATE_COMMUNICATION_PLAN"),
  CREATE_COMMUNICATION_PLAN_CALL: "GCREATE_COMMUNICATION_PLAN_CALL",
  UPDATE_COMMUNICATION_PLAN: asyncActionType("UPDATE_COMMUNICATION_PLAN"),
  UPDATE_COMMUNICATION_PLAN_CALL: "UPDATE_COMMUNICATION_PLAN_CALL",
  DELETE_COMMUNICATION_PLAN: asyncActionType("DELETE_COMMUNICATION_PLAN"),
  DELETE_COMMUNICATION_PLAN_CALL: "DELETE_COMMUNICATION_PLAN_CALL",
  PROJECT_USERS: asyncActionType("PROJECT_USERS"),
  PROJECT_USERS_CALL: "PROJECT_USERS_CALL",
  SORT_COMMUNICATION_PLANS: asyncActionType("SORT_COMMUNICATION_PLANS"),
  SORT_COMMUNICATION_PLANS_CALL: "SORT_COMMUNICATION_PLANS_CALL",
  COMMUNICATION_PLAN_FLAG: asyncActionType("COMMUNICATION_PLAN_FLAG"),
  COMMUNICATION_PLAN_FLAG_CALL: "COMMUNICATION_PLAN_FLAG_CALL",

  // Health Status //
  METRIX_CALL: "METRIX_CALL",
  METRIX: asyncActionType("METRIX"),
  UPDATE_KPI_CALL: "UPDATE_KPI_CALL",
  UPDATE_KPI: asyncActionType("UPDATE_KPI"),

  PROGRESS_TRACKER_CALL: "PROGRESS_TRACKER_CALL",
  PROGRESS_TRACKER: asyncActionType("PROGRESS_TRACKER"),
  UPDATE_PROGRESS_KPI_CALL: "UPDATE_PROGRESS_KPI_CALL",
  UPDATE_PROGRESS_KPI: asyncActionType("UPDATE_PROGRESS_KPI"),

  // Clients //
  CLIENTS_CALL: "CLIENTS_CALL",
  CLIENTS: asyncActionType("CLIENTS"),
  SORT_CLIENTS: asyncActionType("SORT_CLIENTS"),
  SORT_CLIENTS_CALL: "SORT_CLIENTS_CALL",
  CREATE_CLIENT: asyncActionType("CREATE_CLIENT"),
  CREATE_CLIENT_CALL: "CREATE_CLIENT_CALL",
  UPDATE_CLIENT: asyncActionType("UPDATE_CLIENT"),
  UPDATE_CLIENT_CALL: "UPDATE_CLIENT_CALL",
  DELETE_CLIENT: asyncActionType("DELETE_CLIENT"),
  DELETE_CLIENT_CALL: "DELETE_CLIENT_CALL",
  GET_CLIENT_DETAILS: asyncActionType("GET_CLIENT_DETAILS"),
  GET_CLIENT_DETAILS_CALL: "GET_CLIENT_DETAILS_CALL",
  CLIENT_FLAG: asyncActionType("CLIENT_FLAG"),
  CLIENT_FLAG_CALL: "CLIENT_FLAG_CALL",

  //Portfolios

  GET_PORTFOLIO_BUDGET_SUMMARY: asyncActionType("GET_PORTFOLIO_BUDGET_SUMMARY"),
  GET_PORTFOLIO_BUDGET_SUMMARY_CALL: "GET_PORTFOLIO_BUDGET_SUMMARY_CALL",
  
  GET_PORTFOLIO_PROGRESS_SUMMARY: asyncActionType("GET_PORTFOLIO_PROGRESS_SUMMARY"),
  GET_PORTFOLIO_PROGRESS_SUMMARY_CALL: "GET_PORTFOLIO_PROGRESS_SUMMARY_CALL",

  // Client Fortfolio
  CLIENT_PORTFOLIOS_CALL: "CLIENT_PORTFOLIOS_CALL",
  CLIENT_PORTFOLIOS: asyncActionType("CLIENT_PORTFOLIOS"),
  SORT_CLIENT_PORTFOLIOS: asyncActionType("SORT_CLIENT_PORTFOLIOS"),
  SORT_CLIENT_PORTFOLIOS_CALL: "SORT_CLIENT_PORTFOLIOS_CALL",
  CREATE_CLIENT_PORTFOLIOS: asyncActionType("CREATE_CLIENT_PORTFOLIOS"),
  CREATE_CLIENT_PORTFOLIOS_CALL: "CREATE_CLIENT_PORTFOLIOS",
  UPDATE_CLIENT_PORTFOLIOS: asyncActionType("UPDATE_CLIENT_PORTFOLIOS"),
  UPDATE_CLIENT_PORTFOLIOS_CALL: "UPDATE_CLIENT_PORTFOLIOS_CALL",
  DELETE_CLIENT_PORTFOLIOS: asyncActionType("DELETE_CLIENT_PORTFOLIOS"),
  DELETE_CLIENT_PORTFOLIOS_CALL: "DELETE_CLIENT_PORTFOLIOS_CALL",

  // Client Resources
  CLIENT_RESOURCES_CALL: "CLIENT_RESOURCES_CALL",
  CLIENT_RESOURCES: asyncActionType("CLIENT_RESOURCES"),
  SORT_CLIENT_RESOURCES: asyncActionType("SORT_CLIENT_RESOURCES"),
  SORT_CLIENT_RESOURCES_CALL: "SORT_CLIENT_RESOURCES_CALL",

  // Client Communication plan
  CLIENT_COMMUNICATION_CALL: "CLIENT_COMMUNICATION_CALL",
  CLIENT_COMMUNICATION: asyncActionType("CLIENT_COMMUNICATION"),
  SORT_CLIENT_COMMUNICATION: asyncActionType("SORT_CLIENT_COMMUNICATION"),
  SORT_CLIENT_COMMUNICATION_CALL: "SORT_CLIENT_COMMUNICATION_CALL",
  CREATE_CLIENT_COMMUNICATION: asyncActionType("CREATE_CLIENT_COMMUNICATION"),
  CREATE_CLIENT_COMMUNICATION_CALL: "CREATE_CLIENT_COMMUNICATION_CALL",
  UPDATE_CLIENT_COMMUNICATION: asyncActionType("UPDATE_CLIENT_COMMUNICATION"),
  UPDATE_CLIENT_COMMUNICATION_CALL: "UPDATE_CLIENT_COMMUNICATION_CALL",
  DELETE_CLIENT_COMMUNICATION: asyncActionType("DELETE_CLIENT_COMMUNICATION"),
  DELETE_CLIENT_COMMUNICATION_CALL: "DELETE_CLIENT_COMMUNICATION_CALL",

  // Programs
  PROGRAMS_CALL: "PROGRAMS_CALL",
  PROGRAMS: asyncActionType("PROGRAMS"),
  SORT_PROGRAMS: asyncActionType("SORT_PROGRAMS"),
  SORT_PROGRAMS_CALL: "SORT_PROGRAMS_CALL",
  CREATE_PROGRAMS: asyncActionType("CREATE_PROGRAMS"),
  CREATE_PROGRAMS_CALL: "CREATE_PROGRAMS_CALL",
  UPDATE_PROGRAMS: asyncActionType("UPDATE_PROGRAMS"),
  UPDATE_PROGRAMS_CALL: "UPDATE_PROGRAMS_CALL",
  DELETE_PROGRAMS: asyncActionType("DELETE_PROGRAMS"),
  DELETE_PROGRAMS_CALL: "DELETE_PROGRAMS_CALL",
  GET_PROGRAM_DETAILS: asyncActionType("GET_PROGRAM_DETAILS"),
  GET_PROGRAM_DETAILS_CALL: "GET_PROGRAM_DETAILS_CALL",
  PROGRAM_FLAG: asyncActionType("PROGRAM_FLAG"),
  PROGRAM_FLAG_CALL: "PROGRAM_FLAG_CALL",

  GET_PROGRAM_BUDGET_SUMMARY: asyncActionType("GET_PROGRAM_BUDGET_SUMMARY"),
  GET_PROGRAM_BUDGET_SUMMARY_CALL: "GET_PROGRAM_BUDGET_SUMMARY_CALL",
  
  GET_PROGRAM_PROGRESS_SUMMARY: asyncActionType("GET_PROGRAM_PROGRESS_SUMMARY"),
  GET_PROGRAM_PROGRESS_SUMMARY_CALL: "GET_PROGRAM_PROGRESS_SUMMARY_CALL",
  
  // Budgets //
  SORT_BUDGETS_CALL: "SORT_BUDGETS_CALL",
  SORT_BUDGETS: asyncActionType("SORT_BUDGETS"),
  BUDGETS_CALL: "BUDGETS_CALL",
  BUDGETS: asyncActionType("BUDGETS"),
  CREATE_BUDGET_CALL: "CREATE_BUDGET_CALL",
  CREATE_BUDGET: asyncActionType("CREATE_BUDGET"),
  UPDATE_BUDGET_CALL: "UPDATE_BUDGET_CALL",
  UPDATE_BUDGET: asyncActionType("UPDATE_BUDGET"),
  DELETE_BUDGET_CALL: "DELETE_BUDGET_CALL",
  DELETE_BUDGET: asyncActionType("DELETE_BUDGET"),
  BUDGET_FLAG_CALL: "BUDGET_FLAG_CALL",
  BUDGET_FLAG: asyncActionType("BUDGET_FLAG"),

  //  Risks //
  RISK: asyncActionType("RISK"),
  RISK_CALL: "RISK_CALL",
  CREATE_RISK: asyncActionType("CREATE_RISK"),
  CREATE_RISK_CALL: "CREATE_RISK_CALL",
  UPDATE_RISK: asyncActionType("UPDATE_RISK"),
  UPDATE_RISK_CALL: "UPDATE_RISK_CALL",
  DELETE_RISK: asyncActionType("DELETE_RISK"),
  DELETE_RISK_CALL: "DELETE_RISK_CALL",
  SORT_RISKS: asyncActionType("SORT_RISKS"),
  SORT_RISKS_CALL: "SORT_RISKS_CALL",
  RISK_FLAG: asyncActionType("RISK_FLAG"),
  RISK_FLAG_CALL: "RISK_FLAG_CALL",

  // Change Requests //
  SORT_CHANGE_REQUEST_CALL: "SORT_CHANGE_REQUEST_CALL",
  SORT_CHANGE_REQUEST: asyncActionType("SORT_CHANGE_REQUEST"),
  CHANGE_REQUEST_CALL: "CHANGE_REQUEST_CALL",
  CHANGE_REQUEST: asyncActionType("CHANGE_REQUEST"),
  CREATE_CHANGE_REQUEST_CALL: "CREATE_CHANGE_REQUEST_CALL",
  CREATE_CHANGE_REQUEST: asyncActionType("CREATE_CHANGE_REQUEST"),
  UPDATE_CHANGE_REQUEST_CALL: "UPDATE_CHANGE_REQUEST_CALL",
  UPDATE_CHANGE_REQUEST: asyncActionType("UPDATE_CHANGE_REQUEST"),
  DELETE_CHANGE_REQUEST_CALL: "DELETE_CHANGE_REQUEST_CALL",
  DELETE_CHANGE_REQUEST: asyncActionType("DELETE_CHANGE_REQUEST"),
  CREATE_CHANGE_REQUEST_RISK_CALL: "CREATE_CHANGE_REQUEST_RISK_CALL",
  CREATE_CHANGE_REQUEST_RISK: asyncActionType("CREATE_CHANGE_REQUEST_RISK"),
  CHANGE_REQUEST_FLAG_CALL: "CHANGE_REQUEST_FLAG_CALL",
  CHANGE_REQUEST_FLAG: asyncActionType("CHANGE_REQUEST_FLAG"),

  // Meetings //
  FETCH_MEETING: asyncActionType("FETCH_MEETING"),
  FETCH_MEETING_CALL: "FETCH_MEETING_CALL",
  CREATE_MEETING: asyncActionType("CREATE_MEETING"),
  CREATE_MEETING_CALL: "CREATE_MEETING_CALL",
  UPDATE_MEETING: asyncActionType("UPDATE_MEETING"),
  UPDATE_MEETING_CALL: "UPDATE_MEETING_CALL",
  MEETINGS: asyncActionType("MEETINGS"),
  MEETINGS_CALL: "MEETINGS_CALL",
  CANCEL_MEETING: asyncActionType("CANCEL_MEETING"),
  CANCEL_MEETING_CALL: "CANCEL_MEETING_CALL",
  DELETE_MEETING: asyncActionType("DELETE_MEETING"),
  DELETE_MEETING_CALL: "DELETE_MEETING_CALL",
  MEETING_REGISTERY: asyncActionType("MEETING_REGISTERY"),
  MEETING_REGISTERY_CALL: "MEETING_REGISTERY_CALL",
  SORT_MEETING_REGISTERY: asyncActionType("SORT_MEETING_REGISTERY"),
  SORT_MEETING_REGISTERY_CALL: "SORT_MEETING_REGISTERY_CALL",
  MEETING_REGISTERY_PDF: asyncActionType("MEETING_REGISTERY_PDF"),
  MEETING_REGISTERY_PDF_CALL: "MEETING_REGISTERY_PDF_CALL",
  CLEAR_MEETING_REGISTERY: "CLEAR_MEETING_REGISTERY",

  // Assigned Resources
  PROJECT_RESOURCES_CALL: "PROJECT_RESOURCES_CALL",
  PROJECT_RESOURCES: asyncActionType("PROJECT_RESOURCES"),
  CREATE_PROJECT_RESOURCES: asyncActionType("CREATE_PROJECT_RESOURCES"),
  CREATE_PROJECT_RESOURCES_CALL: "CREATE_PROJECT_RESOURCES_CALL",
  UPDATE_PROJECT_RESOURCES: asyncActionType(" UPDATE_PROJECT_RESOURCES"),
  UPDATE_PROJECT_RESOURCES_CALL: "UPDATE_PROJECT_RESOURCES_CALL",
  DELETE_PROJECT_RESOURCE_CALL: "DELETE_PROJECT_RESOURCE_CALL",
  DELETE_PROJECT_RESOURCE: asyncActionType("DELETE_PROJECT_RESOURCE"),
  SORT_PROJECT_RESOURCES: asyncActionType("SORT_PROJECT_RESOURCES"),
  SORT_PROJECT_RESOURCES_CALL: "SORT_PROJECT_RESOURCES_CALL",

  // Allocated Resources
  RESOURCES_CALL: "RESOURCES_CALL",
  RESOURCES: asyncActionType("RESOURCES"),
  SORT_RESOURCES: asyncActionType("SORT_RESOURCES"),
  SORT_RESOURCES_CALL: "SORT_RESOURCES_CALL",
  RESOURCE_FLAG: asyncActionType("RESOURCE_FLAG"),
  RESOURCE_FLAG_CALL: "RESOURCE_FLAG_CALL",

  // Shifts
  SHIFTS_CALL: "SHIFTS_CALL",
  SHIFTS: asyncActionType("SHIFTS"),
  CREATE_SHIFT_CALL: "CREATE_SHIFT_CALL",
  CREATE_SHIFT: asyncActionType("CREATE_SHIFT"),
  UPDATE_SHIFT_CALL: "UPDATE_SHIFT_CALL",
  UPDATE_SHIFT: asyncActionType("UPDATE_SHIFT"),
  DELETE_SHIFT_CALL: "DELETE_SHIFT_CALL",
  DELETE_SHIFT: asyncActionType("DELETE_SHIFT"),
  SORT_SHIFT_CALL: "SORT_SHIFT_CALL",
  SORT_SHIFT: asyncActionType("SORT_SHIFT"),
  ASSIGN_SHIFT_CALL: "ASSIGN_SHIFT_CALL",
  ASSIGN_SHIFT: asyncActionType("ASSIGN_SHIFT"),
  SHIFT_FLAG_CALL: "SHIFT_FLAG_CALL",
  SHIFT_FLAG: asyncActionType("SHIFT_FLAG"),
  EXP_RES: "EXP_RES",
  EXP_CLIENTS: "EXP_CLIENTS",
  EXP_MEETINGS: "EXP_MEETINGS",
  EXP_PROJECTS: "EXP_PROJECTS",

  UPDATE_PERMISSION_STATUS: "UPDATE_PERMISSION_STATUS",

  // Purchase Orders //
  SORT_PURCHASE_ORDERS_CALL: "SORT_PURCHASE_ORDERS_CALL",
  SORT_PURCHASE_ORDERS: asyncActionType("SORT_PURCHASE_ORDERS"),
  PURCHASE_ORDERS_CALL: "PURCHASE_ORDERS_CALL",
  PURCHASE_ORDERS: asyncActionType("PURCHASE_ORDERS"),
  CREATE_PURCHASE_ORDER_CALL: "CREATE_PURCHASE_ORDER_CALL",
  CREATE_PURCHASE_ORDER: asyncActionType("CREATE_PURCHASE_ORDER"),
  UPDATE_PURCHASE_ORDER_CALL: "UPDATE_PURCHASE_ORDER_CALL",
  UPDATE_PURCHASE_ORDER: asyncActionType("UPDATE_PURCHASE_ORDER"),
  DELETE_PURCHASE_ORDER_CALL: "DELETE_PURCHASE_ORDER_CALL",
  DELETE_PURCHASE_ORDER: asyncActionType("DELETE_PURCHASE_ORDER"),
  PURCHASE_ORDER_FLAG_CALL: "PURCHASE_ORDER_FLAG_CALL",
  PURCHASE_ORDER_FLAG: asyncActionType("PURCHASE_ORDER_FLAG"),

  // Invoice Registry //
  SORT_INVOICE_REGISTRY_CALL: "SORT_INVOICE_REGISTRY_CALL",
  SORT_INVOICE_REGISTRY: asyncActionType("SORT_INVOICE_REGISTRY"),
  INVOICE_REGISTRY_CALL: "INVOICE_REGISTRY_CALL",
  INVOICE_REGISTRY: asyncActionType("INVOICE_REGISTRY"),
  CREATE_INVOICE_REGISTRY_CALL: "CREATE_INVOICE_REGISTRY_CALL",
  CREATE_INVOICE_REGISTRY: asyncActionType("CREATE_INVOICE_REGISTRY"),
  UPDATE_INVOICE_REGISTRY_CALL: "UPDATE_INVOICE_REGISTRY_CALL",
  UPDATE_INVOICE_REGISTRY: asyncActionType("UPDATE_INVOICE_REGISTRY"),
  DELETE_INVOICE_REGISTRY_CALL: "DELETE_INVOICE_REGISTRY_CALL",
  DELETE_INVOICE_REGISTRY: asyncActionType("DELETE_INVOICE_REGISTRY"),
  INVOICE_REGISTRY_FLAG_CALL: "INVOICE_REGISTRY_FLAG_CALL",
  INVOICE_REGISTRY_FLAG: asyncActionType("INVOICE_REGISTRY_FLAG"),

  // Decision Log //
  SORT_DECISION_LOG_CALL: "SORT_DECISION_LOG_CALL",
  SORT_DECISION_LOG: asyncActionType("SORT_DECISION_LOG"),
  DECISION_LOG_CALL: "DECISION_LOG_CALL",
  DECISION_LOG: asyncActionType("DECISION_LOG"),
  CREATE_DECISION_LOG_CALL: "CREATE_DECISION_LOG_CALL",
  CREATE_DECISION_LOG: asyncActionType("CREATE_DECISION_LOG"),
  UPDATE_DECISION_LOG_CALL: "UPDATE_DECISION_LOG_CALL",
  UPDATE_DECISION_LOG: asyncActionType("UPDATE_DECISION_LOG"),
  DELETE_DECISION_LOG_CALL: "DELETE_DECISION_LOG_CALL",
  DELETE_DECISION_LOG: asyncActionType("DELETE_DECISION_LOG"),
  DECISION_LOG_FLAG_CALL: "DECISION_LOG_FLAG_CALL",
  DECISION_LOG_FLAG: asyncActionType("DECISION_LOG_FLAG"),

  // Navigation //
  NAVIGATE_TO_ENTITY: "NAVIGATE_TO_ENTITY",
  NAVIGATE_BACK: "NAVIGATE_BACK",
  NAVIGATE_FORWARD: "NAVIGATE_FORWARD",
  NAVIGATE_TO_HISTORY_INDEX: "NAVIGATE_TO_HISTORY_INDEX",
  SYNC_WITH_ROUTE: "SYNC_WITH_ROUTE",
  UPDATE_ENTITY_TAB: "UPDATE_ENTITY_TAB",
  SET_DIRECT_NAVIGATION: "SET_DIRECT_NAVIGATION",
  CLEAR_NAVIGATION: "CLEAR_NAVIGATION",
  RESET_BREADCRUMB: "RESET_BREADCRUMB",
  ADD_TO_BREADCRUMB: "ADD_TO_BREADCRUMB",
  REMOVE_FROM_BREADCRUMB: "REMOVE_FROM_BREADCRUMB",
};

export default {
  ...FILTER_ACTIONS,
};

export const MESSAGE_BOX_TYPE = {
  SUCCESS_EXPIRE: 1,
};

export const FETCH_STATUS = {
  LOADING: "LOADING",
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
};

export const SCREEN_SIZE_MOBILE = "MOBILE";
export const SCREEN_SIZE_TABLET = "TABLET";
export const SCREEN_SIZE_MEDIUM_TABLET = "MEDIUMTABLET";
export const SCREEN_SIZE_DESKTOP = "DESKTOP";
export const SCREEN_SIZE_LAPTOP = "LAPTOP";

export const IMAGE_BASE_URL = "";

export const NO_RESULTS_FOUND = "No results found";
